<div class="card-container">
  <div class="radio">
    Detect:
    <input id="hands" type="radio" name="model" value="hands"
           (change)="this.uploadService.model= this.uploadService.MODEL_HANDS" checked>
    <label for="hands">Hands</label>
    <input id="pose" type="radio" name="model" value="pose"
           (change)="this.uploadService.model= this.uploadService.MODEL_POSE">
    <label for="pose">Pose</label>
    <input id="face" type="radio" name="model" value="face"
           (change)="this.uploadService.model= this.uploadService.MODEL_FACE">
    <label for="face">Face</label>
  </div>
</div>

<div class="card-container">
  <div class="radio">
    <input id="uploadVideo" type="radio" name="uploadWay" value="uploadVideo"
           (change)="onSelectionChange('uploadVideo')" checked>
    <label for="uploadVideo">Upload a video</label>
    <input id="createVideo" type="radio" name="uploadWay" value="createVideo"
           (change)="onSelectionChange('createVideo')">
    <label for="createVideo">Create a video</label>
  </div>
</div>
<div *ngIf="!createVideo">
  <app-upload></app-upload>
</div>
<div *ngIf="createVideo">
  <app-video></app-video>
</div>
